import { ViewStream } from "spyne";

export class PageHomePluginSection extends ViewStream {
  constructor(props = {}) {
    props.class = "external-section";
    props.id = "home-plugins-section";
    props.template = require("./templates/page-home-plugin-section.tmpl.html");
    super(props);
  }

  addActionListeners() {
    // return nexted array(s)
    return [];
  }

  broadcastEvents() {
    // return nexted array(s)
    return [];
  }

  onRendered() {}
}
